import DataTracker, {
  TrackerClientInstance,
} from "@hk01-digital/data-tracker-client"
import Cookies from "js-cookie"
import React, {
  ReactNode,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react"

import AppStateContext, {
  DataTrackingParameter,
} from "../AppContent/AppStateContext"
import DataTrackContext, { EventLabelParams } from "./trackingContext"
import { getListingPageByTabKey } from "./utils/getListingPageByTabKey"

export interface Props {
  children: ReactNode
}

const getDefaultLabelData = (trackingParameter: DataTrackingParameter) => ({
  account_id: null,
  anonymous_id: Cookies.get("hk01_annonymous_id") || null,
  bucket_id: "00000",
  session_id: null,
  ts: Date.now(),
  ...trackingParameter,
})

const DataTrackingProvider = ({ children }: Props) => {
  const { trackerConfig, trackingParameter = {} } = useContext(AppStateContext)
  const [dataTracker, setDataTracker] = useState<TrackerClientInstance>()
  useEffect(() => {
    setDataTracker(DataTracker(trackerConfig, false))
  }, [trackerConfig])

  const computeEventLabel = useCallback(
    (data: EventLabelParams) =>
      JSON.stringify({
        ...getDefaultLabelData(trackingParameter),
        ...data,
      }),
    [trackingParameter],
  )

  const value = useMemo(
    () => ({ dataTracker, getListingPageByTabKey, computeEventLabel }),
    [dataTracker, computeEventLabel],
  )

  return (
    <DataTrackContext.Provider value={value}>
      {dataTracker && children}
    </DataTrackContext.Provider>
  )
}

export default DataTrackingProvider
